import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import AuthCallback from './components/AuthCallback';
import Landing from './pages/Landing';
import Login from './pages/Login';
import ChatApp from './pages/ChatApp';
import Agents from './pages/Agents';
import BuildAgent from './pages/BuildAgent';
import Upgrade from './pages/Upgrade';
import Account from './pages/Account';
import Admin from './pages/Admin';
import Shared from './pages/Shared';
import Gallery from './pages/Gallery';
import { ForgotPassword, ResetPassword } from './pages/PasswordReset';
import { PaymentSuccess, PaymentCancel } from './pages/Payment';

const P = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/share/:shareId" element={<Shared />} />
      <Route path="/admin" element={<P><Admin /></P>} />
      <Route path="/chat" element={<P><ChatApp /></P>} />
      <Route path="/chat/:conversationId" element={<P><ChatApp /></P>} />
      <Route path="/agents" element={<P><Agents /></P>} />
      <Route path="/build" element={<P><BuildAgent /></P>} />
      <Route path="/build/:agentId" element={<P><BuildAgent /></P>} />
      <Route path="/gallery" element={<P><Gallery /></P>} />
      <Route path="/upgrade" element={<P><Upgrade /></P>} />
      <Route path="/account" element={<P><Account /></P>} />
      <Route path="/payment/success" element={<P><PaymentSuccess /></P>} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.title = 'Aurra AI — Your AI assistant, without limits';
  }, []);
  return (
    <div className="App">
      <AppProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </AuthProvider>
      </AppProvider>
    </div>
  );
}

export default App;
